import { serviceGetClientsProgram } from "../services/Client.service";
import EventEmitter from "../libs/Events.utils";
import store from "../store";
import constants from "../config/constants";


export const FETCH_INIT = 'FETCH_INIT_CLIENT_PROGRAM';
export const FETCHED = 'FETCHED_CLIENT_PROGRAM';
export const FETCHED_FAIL = 'FETCHED_FAIL_CLIENT_PROGRAM';
export const FETCHED_FILTER = 'FETCHED_FILTER_CLIENT_PROGRAM';
export const FETCH_NEXT = 'FETCH_NEXT_CLIENT_PROGRAM';
export const FILTER = 'FILTER_CLIENT_PROGRAM';
export const RESET_FILTER = 'RESET_FILTER_CLIENT_PROGRAM';
export const SET_SORTING = 'SET_SORTING_CLIENT_PROGRAM';
export const SET_FILTER = 'SET_FILTER_CLIENT_PROGRAM';
export const SET_PAGE = 'SET_PAGE_CLIENT_PROGRAM';
export const CHANGE_PAGE = 'CHANGE_PAGE_CLIENT_PROGRAM';
export const CHANGE_STATUS = 'CHANGE_STATE_CLIENT_PROGRAM';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_CLIENT_PROGRAM';

export const CREATE_DATA = 'CREATE_CLIENT_PROGRAM';
export const UPDATE_DATA = 'UPDATE_CLIENT_PROGRAM';
export const DELETE_ITEM = 'DELETE_CLIENT_PROGRAM';



export function actionFetchClientsPrograms(index = 1, sorting = {}, filter = {}, shouldReset = false) {
    const request = serviceGetClientsProgram({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data?.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({ type: CHANGE_PAGE, payload: index - 1 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}

export function actionSetPageClientsPrograms(page) {
    const stateData = store.getState().client_programs;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchClientsPrograms(serverPage + 1, sortingData, { query, query_data: queryData }));
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}